"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("circle", { cx: "31.5", cy: "16.404", r: "3.094" }),
  React.createElement("path", { d: "M46 6H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h3.545A16.5 16.5 0 0 1 10 36.409 14.753 14.753 0 0 1 7.317 28.2a15.489 15.489 0 0 1 .116-1.806A25.1 25.1 0 0 0 4 29.7V10h40v21.311c-1.919-2.034-7.22-5.908-8.762-5.847-1.116.083-4.42 3.017-6.769 4.47a14.964 14.964 0 0 1-2.455 6.507A17.036 17.036 0 0 1 30.345 38H46a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2z" }),
  React.createElement("path", { d: "M32 45.5a3.97 3.97 0 0 0-1.333-2.994 12.872 12.872 0 0 0-7.3-2.844A1.456 1.456 0 0 1 22.1 38.2v-2.106a1.416 1.416 0 0 1 .351-.918 11.133 11.133 0 0 0 2.558-6.976c0-5.261-2.79-8.2-7.006-8.2s-7.086 3.055-7.086 8.2a11.266 11.266 0 0 0 2.679 6.98 1.406 1.406 0 0 1 .348.913v2.1a1.449 1.449 0 0 1-1.264 1.462A12.337 12.337 0 0 0 5.286 42.5 3.979 3.979 0 0 0 4 45.45V48h28z" })
);

